<template>
  <div class="group-container" :style="{ ...position, display: visible ? 'inline-block' : 'none' }">
    <slot></slot>
  </div>
</template>

<script setup>
import { defineProps, defineExpose } from "vue"
import useToggle from "@p-v/hooks/useToggle"

// interface GroupProp {
//   position: any;
//   id: string;
// }

const props = defineProps({
  customStyle: {
    type: Object,
  },
  position: {
    type: Object,
  },
})

// const propsPosition: any = toRaw(props.position);
// const initVisible = computed(() => propsPosition.display != 'none');
// console.log('props initVisible', initVisible.value);
const { visible, changeVisible } = useToggle(props.position?.display != "none")
// const { visible } = toRefs(toggoleData);

defineExpose({
  show: () => changeVisible(true),
  hide: () => changeVisible(false),
  toggle: () => changeVisible(),
})
</script>

<style lang="scss">
.group-container {
  position: absolute;
}
</style>
